import { WifiOff, RefreshCw } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";
import { useTranslation } from "@/hooks/useTranslation";

export function OfflineBanner() {
  const isOnline = useOnlineStatus();
  const { translate: t } = useTranslation();

  if (isOnline) return null;

  return (
    <Alert variant="destructive" className="rounded-none border-0 border-b">
      <WifiOff className="h-4 w-4" />
      <AlertDescription className="flex items-center justify-between">
        <span>{t("offline_banner_message")}</span>
        <Button 
          size="sm" 
          variant="outline" 
          onClick={() => window.location.reload()}
          className="ml-4"
        >
          <RefreshCw className="h-3 w-3 mr-2" />
          {t("offline_banner_retry")}
        </Button>
      </AlertDescription>
    </Alert>
  );
}
